import { axios } from '@/plugins/axios';
import { KeyValuePair, Resource, Statement } from '@/helpers/Interfaces';
import { Column } from '../../common/services/GridService';
import { DateTime } from 'luxon';

export default class RegisterDatasourcesService
{
    public static async saveGlobalSource(form: SourceDetailsModel): Promise<Statement>
    {
        return (await axios.post('integrators', form)).data;
    }

    public static async saveModuleSource(form: SourceDetailsModel, moduleId: string): Promise<Statement>
    {
        return (await axios.post(`modules/${moduleId}/integrators`, form)).data;
    }

    public static async editSources(id: string, form: SourceDetailsModel): Promise<Statement>
    {
        return (await axios.put(`integrators/${id}`, form)).data;
    }

    public static async runDataSource(id: string): Promise<Statement>
    {
        return (await axios.put(`integrators/${id}/run`)).data;
    }

    public static async getSources(id: string): Promise<Resource<SourceDetailsModel>>
    {
        return (await axios.get(`simple-fetch/integrators/${id}`)).data;
    }

    public static async fetchSourceTypeConfiguration(type: string, moduleId: string): Promise<SourceFieldsConfig>
    {
        return (
            await axios.get(`admin/integrators/${type}/json`, {
                params: { moduleId },
            })
        ).data;
    }

    public static async fetchHistoryDetails(publicId: string): Promise<Resource<DetailsHistoryModel>>
    {
        return (await axios.get(`simple-fetch/integrator-history/${publicId}`)).data;
    }

    public static async getOcrEnabled(): Promise<boolean>
    {
        return (await axios.get('admin/settings/ocr/enabled')).data;
    }

    public static async getAiEnabled(): Promise<boolean>
    {
        const cacheKey = `ai-enabled`;
        const cachedData = sessionStorage.getItem(cacheKey);

        if (cachedData)
        {
            return Boolean(cachedData);
        }

        const data = (await axios.get<boolean>('admin/settings/ai/enabled')).data;

        sessionStorage.setItem(cacheKey, data.toString());
        // Cache persists until page refresh (sessionStorage is cleared on refresh)

        return data;
    }
}

export interface ListItemModel {
    id: number;
    dateCreatedUtc: string;
    name: string;
    sourceType: string;
    dictionaryType: string;
    isActive: boolean;
}

export interface SourceDetailsModel {
    activeToUtc: string;
    companyId: KeyValuePair;
    documentType: KeyValuePair;
    register: KeyValuePair;
    sourceType: KeyValuePair;
    name: Record<string, string>;
    configuration: any;
    barcodesEnabled: boolean;
    cron: string;
    skipQueueing: boolean;
    script: KeyValuePair;
    scriptConfigId: string;
    authType: KeyValuePair;
    useSystemApiKey: boolean;
    apiKey: string;
    basicLogin: string;
    basicPassword: string;
    validationScript: KeyValuePair;
    validationScriptConfigId: string;
}

export interface FilterModel {
    status: any;
}

export interface SourceConfig extends Column {
    hint?: string;
    dataSource: string;
}

export interface SourceFieldsConfig {
    [fieldName: string]: SourceConfig;
}

export interface DetailsHistoryModel {
    publicId: string;
    dateExecuteUtc: DateTime;
    errorMessage: string;
    status: KeyValuePair;
    dateStartUtc?: DateTime;
    durationFormatted: string;
}
